import { statRootOf } from '../../../config/matchStatsCaptions';

// What a Maestro command does to the on-air stat tile: the caption it puts on
// air, null when it takes the stats off, undefined when it leaves them alone.
export const statOnAirChange = (cmd, statGraphic) => {
  const layer = cmd?.layer ?? cmd?.caption?.id;
  const action = String(cmd?.caption?.action || '');
  if (layer !== statGraphic || cmd?.caption?.mode === 'PREVIEW') return undefined;
  if (statRootOf(action, 'IN')) return cmd?.preset ?? cmd?.caption?.preset ?? undefined;
  if (action === 'OUT' || statRootOf(action, 'OUT')) return null;
  return undefined;
};
